import { customersRepositoryOfflineAdapters } from '../../../../../../../offline/offlineRequestAdapters/customers.repository.offlineAdapters';
import { priceTablesRepositoryOfflineAdapters } from '../../../../../../../offline/offlineRequestAdapters/priceTables.repository.offlineAdapters';
import { salesRepresentativesRepositoryOfflineAdapters } from '../../../../../../../offline/offlineRequestAdapters/salesRepresentatives.repository.offlineAdapters';
import { sellersRepositoryOfflineAdapters } from '../../../../../../../offline/offlineRequestAdapters/sellers.repository.offlineAdapters';
import { createAsyncAutocompleteOfflineFetcher } from '../../../../../../../offline/utils/createAsyncAutocompleteOfflineFetcher.util';
import {
  BuildOrderGeneralDataOfflineFetchersParams,
  OrderGeneralDataFetchers,
  OrderSellerOption,
} from './orderGeneralDataOfflineFetchers.types';

export const buildCurrentUserSellerFetcher = ({
  userId,
  name,
}: Pick<OrderSellerOption, 'userId' | 'name'>) =>
  createAsyncAutocompleteOfflineFetcher<OrderSellerOption>({
    queryField: 'name',
    fetchPage: async () => ({ data: [{ id: userId, userId, name }], count: 1 }),
  });

export const buildOrderGeneralDataOfflineFetchers = ({
  isOfflineMode,
  isAdminBrand,
  customerId,
}: BuildOrderGeneralDataOfflineFetchersParams): OrderGeneralDataFetchers | undefined => {
  if (!isOfflineMode) {
    return undefined;
  }

  return {
    customer: createAsyncAutocompleteOfflineFetcher({
      queryField: 'query',
      fetchPage: customersRepositoryOfflineAdapters.page,
    }),
    seller: createAsyncAutocompleteOfflineFetcher({
      queryField: 'name',
      fetchPage: sellersRepositoryOfflineAdapters.page,
    }),
    salesRepresentative: createAsyncAutocompleteOfflineFetcher({
      queryField: 'nameOrCode',
      fetchPage: ({ limit, skip }) =>
        salesRepresentativesRepositoryOfflineAdapters.page({
          limit,
          skip,
          customerId: isAdminBrand ? undefined : customerId,
        }),
    }),
    priceTable: createAsyncAutocompleteOfflineFetcher({
      queryField: 'nameOrCode',
      fetchPage: priceTablesRepositoryOfflineAdapters.page,
    }),
  };
};
